import { Env } from '~/types/environment'
import { getStampinupDomain, getStampinupDomainEnvPrefix } from '~/utils/locale'
import { useLocaleStore } from '~/stores/locale'
import { PORTAL_REPORTS } from '~/utils/portalRoutes'
import { useTypedRuntimeConfig } from '~/utils/runtimeConfig'

export const domainPrefix = () => {
  const config = useTypedRuntimeConfig()
  const prefix = getStampinupDomainEnvPrefix(config.public.ENVIRONMENT ?? Env.Release)
  return prefix
}

// Same shape as useBlogUrl/usePoliciesUrl - a named ref that follows the
// locale - so the three read alike where they are combined (useHeaderTopLinks).
export const useReportsUrl = (routeToPage?: string) => {
  // Both lookups can miss (unknown culture, unrecognised ENVIRONMENT), and nuxt2
  // falls back rather than interpolating "undefined"/"null" into the URL.
  const urlPrefix = domainPrefix() ?? ''
  const localeStore = useLocaleStore()
  const reportsUrl = computed(() => {
    const domain = getStampinupDomain(localeStore.culture) ?? 'stampinup.com'
    const url = `https://${urlPrefix}${domain}${PORTAL_REPORTS}/`
    return routeToPage ? `${url}?routeToPage=${routeToPage}` : url
  })

  return { reportsUrl }
}
